import type { AddEthereumChainParameter } from '@web3-react/types'

const PolygonMATIC: AddEthereumChainParameter['nativeCurrency'] = {
  name: 'MATIC',
  symbol: 'MATIC',
  decimals: 18,
}

interface BasicChainInformation {
  urls: string[]
  name: string
}

interface ExtendedChainInformation extends BasicChainInformation {
  nativeCurrency: AddEthereumChainParameter['nativeCurrency']
  blockExplorerUrls: AddEthereumChainParameter['blockExplorerUrls']
}

function isExtendedChainInformation(
  chainInformation: BasicChainInformation | ExtendedChainInformation,
): chainInformation is ExtendedChainInformation {
  return !!(chainInformation as ExtendedChainInformation).nativeCurrency
}

export function getAddChainParameters(chainId: number): AddEthereumChainParameter | number {
  const chainInformation = CHAINS[chainId]
  if (isExtendedChainInformation(chainInformation)) {
    return {
      chainId,
      chainName: chainInformation.name,
      nativeCurrency: chainInformation.nativeCurrency,
      rpcUrls: chainInformation.urls,
      blockExplorerUrls: chainInformation.blockExplorerUrls,
    }
  } else return chainId
}

export const REACT_APP_ENV = process.env.REACT_APP_ENV || 'uat'
console.log('REACT_APP_ENV', REACT_APP_ENV)

export const CHAINS_ENV: any = {
  dev: {
    80001: {
      urls: ['https://polygon-mumbai.infura.io/v3/4458cf4d1689497b9a38b1d6bbf05e78'].filter((url) => url !== undefined),
      name: 'Polygon Testnet',
      nativeCurrency: PolygonMATIC,
      blockExplorerUrls: ['https://mumbai.polygonscan.com'],
    },
  },
  uat: {
    97: {
      urls: ['https://go.getblock.io/1c76e307f5d549f4a42119369737b16d'].filter((url) => url !== undefined),
      name: 'BSC Testnet',
      blockExplorerUrls: ['https://testnet.bscscan.com'],
    },
  },
  prd: {
    56: {
      urls: ['https://bsc-dataseed.binance.org/'].filter((url) => url !== undefined),
      name: 'BNB Smart Chain',
    },
  },
}

export const CHAINS: any = CHAINS_ENV[REACT_APP_ENV]

export const URLS: { [chainId: number]: string[] } = Object.keys(CHAINS).reduce<{ [chainId: number]: string[] }>((accumulator, chainId) => {
  const validURLs: string[] = CHAINS[Number(chainId)].urls

  if (validURLs.length) accumulator[Number(chainId)] = validURLs

  return accumulator
}, {})
